@if (remote | async; as r) {
  <ftr-remote
    class="animated-remote"
    [ngClass]="{ 'animated-remote--fill': displayMode === 'FILL', 'animated-remote--block': displayMode !== 'FILL' }"
    [remote]="r"
    [notAskedTemplate]="notAsked"
    [loadingTemplate]="loading"
    [failureTemplate]="failure"
    [successTemplate]="success"
    [emptyTemplate]="empty"
    [isEmpty]="isEmpty"
  >
    <ng-template #notAsked>
      <div class="animated-remote__state animated-remote__state--not-asked" [@fade]>
        <ng-container *ngTemplateOutlet="notAskedTemplate" />
      </div>
    </ng-template>
    <ng-template #loading>
      <div class="animated-remote__state animated-remote__state--loading" [@fade]>
        <ng-container *ngTemplateOutlet="loadingTemplate" />
      </div>
    </ng-template>
    <ng-template #failure let-error>
      <div class="animated-remote__state animated-remote__state--error" [@fade]>
        <ng-container *ngTemplateOutlet="failureTemplate; context: { $implicit: error }" />
      </div>
    </ng-template>
    <ng-template #success let-data>
      @if (disableSuccessTemplateFade) {
        <div class="animated-remote__state animated-remote__state--primary">
          <ng-container *ngTemplateOutlet="successTemplate; context: { $implicit: data }" />
        </div>
      } @else {
        <div class="animated-remote__state animated-remote__state--primary" [@fade]>
          <ng-container *ngTemplateOutlet="successTemplate; context: { $implicit: data }" />
        </div>
      }
    </ng-template>
    <ng-template #empty let-data>
      <div class="animated-remote__state animated-remote__state--empty" [@fade]>
        <ng-container *ngTemplateOutlet="emptyTemplate; context: { $implicit: data }" />
      </div>
    </ng-template>
  </ftr-remote>
}
